import { gameStateManager } from '../../App';
import { utils } from '../../utils'
import { pixiGameUtils } from '../PixiGame/PixiGameUtils'

export const CONSOLE_MESSAGE_TYPE =
{
  PLACED_TILE: 0,
  PLACED_MEEPLE: 1,
  PLAYER_DISCONNECTED: 2,
  PLAYER_DISCONNECTED_TO_BOT: 3,
  PLAYER_AWAY: 4,
  PLAYER_RECONNECTED: 5,
  SPECTATOR_CONNECTED: 6,
  SPECTATOR_DISCONNECTED: 7,
  PLAYER_SCORED_FEATURE: 8
};

export function featureTypeValueToImgTagString( featureTypeValue )
{
  let featureTypeString = pixiGameUtils.featureTypeValueToString( featureTypeValue );
  return `<img src="./ui/feature-icon-${featureTypeString.toLowerCase()}-32.png" class="console-message-feature-icon-img console-message-${featureTypeString}-icon-img" alt="${featureTypeString}" />`;
}

export function parseInfoConsoleMessageDataToText( messageData )
{
  // console.log( "Console MessageData :", messageData );

  if( messageData.type === CONSOLE_MESSAGE_TYPE.PLACED_TILE )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    const coords = messageData.coords[ 0 ];
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> placed a tile [${coords.x},${coords.y}]`,
      playerIconID: playerIconID,
      teamColourID: playerColourID,
      onClick: () =>
      {
        console.log( "Clicked tile placement info line...", coords );

        gameStateManager.broadcastGameInfoConsoleTileHighlightRequest( coords );
      }
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLACED_MEEPLE )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    // const coords = messageData.coords[0];
    const playerIconID = messageData.playerIconIDs[ 0 ];
    const featureType = messageData.featureType;

    const meepleImgTag = `<img src="./ui/Meeple Counter Filled - ${utils.capitalizeFirstLetter( playerColourID )}.png" class="console-message-inline-meeple-img" alt="tilefolk" />`;

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> placed ${meepleImgTag} on ${featureTypeValueToImgTagString( featureType )}`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLAYER_SCORED_FEATURE )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    // const coords = messageData.coords[0];
    const playerIconID = messageData.playerIconIDs[ 0 ];
    const featureType = messageData.featureType;
    const featureScore = messageData.value;

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> scored <span class="console-message-score-span">${featureScore}</span> from ${featureTypeValueToImgTagString( featureType )}`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLAYER_DISCONNECTED )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> has disconnected.`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLAYER_DISCONNECTED_TO_BOT )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> has now been set as a BOT until they return.`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLAYER_AWAY )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    const playerIconID = messageData.playerIconIDs[ 0 ];
    const disconnectedTimeoutDuration = messageData.value;

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> disconnected. Waiting ${disconnectedTimeoutDuration} seconds before setting them as a BOT.`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.PLAYER_RECONNECTED )
  {
    const playerName = messageData.playerNames[ 0 ];
    const playerColourHex = messageData.playerColourHexs[ 0 ];
    const playerColourID = messageData.playerColourIDs[ 0 ];
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#${playerColourHex};">${playerName}</span> has reconnected.`,
      playerIconID: playerIconID,
      teamColourID: playerColourID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.SPECTATOR_CONNECTED )
  {
    const spectatorName = messageData.value;
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#333333;">${spectatorName}</span> has joined as a spectator.`,
      playerIconID: playerIconID
    };
  }
  else if( messageData.type === CONSOLE_MESSAGE_TYPE.SPECTATOR_DISCONNECTED )
  {
    const spectatorName = messageData.value;
    const playerIconID = messageData.playerIconIDs[ 0 ];

    return {
      text: `<span style="fontWeight:bold;color:#333333;">${spectatorName}</span> spectator has disconnected.`,
      playerIconID: playerIconID
    };
  }

  console.log( "Unhandled message type! messageData : ", messageData );

  return { text: 'Unhandled message type!' };
}





